module.exports = __webpack_public_path__ + "static/media/sgp.28cda264.svg";